<div class="container" id="home-container">
  <div class="header">
    <span id="home-header-title">{{ 'HOME.TITLE' | translate }}</span>
  </div>
  <div class="cards-container">
    @for (card of homeCards(); track card.id) {
    <div class="card" [id]="card.id + '-card'">
      <div class="track-icon">
        <img [src]="card.iconSrc" alt="logo" />
      </div>
      <div class="card-body">
        <div class="card-title">
          <span [id]="card.id + '-card-title'">
            {{ card.titleKey | translate }}
          </span>
        </div>

        <ul [id]="card.id + '-tabs'">
          @for (tab of card.tabs; track tab.path) {
          <li
            [ngClass]="{
              'active': !tab.disabled,
              'disable': tab.disabled
            }"
          >
            <a
              role="tab"
              [attr.aria-selected]="!tab.disabled"
              [attr.aria-disabled]="tab.disabled"
              [attr.tabindex]="tab.disabled ? -1 : null"
              [routerLink]="tab.disabled ? null : [card.basePath, tab.path]"
            >
              {{ tab.label | translate }}
            </a>
          </li>
          }
        </ul>
      </div>
    </div>
    }
  </div>
</div>
